module.exports = __webpack_public_path__ + "static/terra-mattress-2-289f13c08ecf81b7eae111ec4330e25f.png";